export { EditorDocumento } from './EditorDocumento'
